import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendly-manager',
  templateUrl: './calendly-manager.component.html',
  styleUrls: ['./calendly-manager.component.css']
})
export class CalendlyManagerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  copyToCLipboard(link){

  }
}
